{
  "slug": "mensa-iq-requirements",
  "title": "IQ का अर्थ है बुद्धि।",
  "description": "यह जानना महत्वपूर्ण है कि मेनसा योग्यता शीर्ष दो प्रतिशत का उपयोग कैसे करती है, योग्यता संख्याएं परीक्षा के अनुसार क्यों भिन्न होती हैं और ऑनलाइन स्कोर प्रवेश प्रमाण नहीं हैं।",
  "summary": "मेनसा प्रतिशत शब्दों में योग्यता का वर्णन करता है: एक योग्यता परिणाम पर या उससे ऊपर होना चाहिए 98अनुमोदित, उचित रूप से नियंत्रित बुद्धि परीक्षण पर 100% अंक. संबंधित आईक्यू संख्या पैमाने पर भिन्न होती है.",
  "category": "तुलना",
  "sections": [
    {
      "heading": "आवश्यकता एक प्रतिशत है, एक सार्वभौमिक संख्या नहीं",
      "paragraphs": [
        "मेन्सा इंटरनेशनल का कहना है कि सदस्यता उन लोगों के लिए खुली है जो सामान्य जनसंख्या के शीर्ष दो प्रतिशत के भीतर अंक प्राप्त करते हैं, जो एक अनुमोदित खुफिया परीक्षण पर हैं जो उचित रूप से प्रशासित और निगरानी में है।",
        "द 98th percentile is often close to 130 एक मध्य-100, एसडी-15 स्केल, लेकिन अन्य परीक्षणों में भिन्न मानक विचलन, अंक प्रकार तथा कटऑफ का प्रयोग होता है. विशिष्ट परीक्षण के लिए स्वीकार्य सीमा को जाँचा जाना चाहिए."
      ]
    },
    {
      "heading": "एक योग्य परिणाम प्रदान करने के तरीके",
      "paragraphs": [
        "राष्ट्रीय मेन्सा संगठन के आधार पर, उम्मीदवार एक प्रशासित प्रवेश परीक्षा ले सकता है या किसी अन्य अनुमोदित मूल्यांकन से सबूत प्रस्तुत कर सकता है।",
        "मूल पेशेवर स्कोर रिपोर्ट रखें. यदि योग्यता का उद्देश्य है तो बाहरी परीक्षण की व्यवस्था करने से पहले संबंधित Mensa कार्यालय से संपर्क करें."
      ]
    },
    {
      "heading": "क्या अभ्यास और ऑनलाइन परीक्षा कर सकते हैं",
      "paragraphs": [
        "अभ्यास प्रश्न किसी को प्रारूप और समय समझने में मदद कर सकते हैं. वे योग्यता साबित नहीं करते हैं, और बार-बार प्रकट होने से सामान्य क्षमता में स्थिर परिवर्तन को मापने के बजाय परिचितता में सुधार हो सकता है.",
        "मेन्सा इंटरनेशनल का कहना है कि ऑनलाइन परीक्षाओं का उपयोग प्रवेश के लिए नहीं किया जा सकता है. एक ऑनलाइन परिणाम को शैक्षणिक या संकेतक के रूप में व्यवहार करें जब तक कि प्राप्त संगठन स्पष्ट रूप से अन्यथा नहीं कहता है।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "क्या IQ स्कोर आप Mensa के लिए जरूरत है?",
      "answer": "पात्रता निम्नलिखित पर आधारित है: 98अनुमोदित पर्यवेक्षित परीक्षण पर 100% प्रतिशत. समतुल्य संख्या परीक्षण पैमाने पर भिन्न होती है."
    },
    {
      "question": "क्या मैं ऑनलाइन आईक्यू परिणाम के साथ Mensa में शामिल हो सकता हूं?",
      "answer": "मेनसा इंटरनेशनल का कहना है कि ऑनलाइन परीक्षणों का उपयोग प्रवेश के लिए नहीं किया जा सकता है।"
    }
  ],
  "related": ["iq-test-vs-mensa-test", "what-is-considered-a-high-iq", "iq-percentiles"],
  "sources": [
    {
      "label": "मेनसा इंटरनेशनल - अपने आईक्यू परीक्षण प्राप्त करना",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
